import { NamedEntityDto } from './named.dto';

export class MacroscopicInspectionTypeDto extends NamedEntityDto {}
